 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		55: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		55: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app/" + ({"2":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","3":"vendors~Assessments~GoalDetails~LearnosityEduAuthor~MemberHomepage~ProgressTracker","4":"AssignmentsModal~AssignmentsModalV2~KidFrameDetail~TakeAssessmentModal","5":"AssignmentsV2~HomeLearning~PredefinedCollectionsDetail~SubPlansList","6":"vendors~Assessments~MyStudents~RegistrationModal~SwitchAccountModal","8":"AnonymousHomepage~RelatedGuidedLesson","9":"LandingPage~Pricing","10":"RegistrationModal~SwitchAccountModal","11":"vendors~Checkout~Gift","13":"AccountSettings","14":"AnonymousHomepage","15":"Assessments","16":"Assignments","17":"AssignmentsModal","18":"AssignmentsModalV2","19":"AssignmentsV2","20":"BackToSchoolBundle","21":"BrainzyPaint","22":"Checkout","23":"FeaturedArtwork","24":"Gift","25":"GoalDetails","26":"GradeFilteredContentCards","27":"GradeWorksheetModal","28":"HomeLearning","29":"KidFrame","30":"KidFrameDetail","31":"LandingPage","32":"LearnosityEduAuthor","33":"MemberHomepage","34":"MyCollections","35":"MyStudents","36":"Onboarding","37":"PracticeSkill","38":"PredefinedCollectionsDetail","39":"Pricing","40":"ProgressTracker","41":"RegistrationModal","42":"RelatedGuidedLesson","43":"Reviews","44":"SeasonalDaysDropdown","45":"Sellpage","46":"SubPlansList","47":"SwitchAccountModal","48":"TakeAssessmentModal","49":"vendors~AssignmentsV2","50":"vendors~Checkout","51":"vendors~Gift","52":"vendors~MemberHomepage","53":"vendors~MyStudents","54":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"d35afebf374f10164c77","1":"54841e04bc6b5a5b1e6b","2":"7641e4f82d4dfef37f34","3":"43abd0994361c96b82f9","4":"0e221b75cafc44c9e539","5":"58d93f19e7328a980131","6":"d4d8038fbbdb827406fd","7":"d3a409ad9a9a85c62373","8":"18981e6cc3e0d9641094","9":"0211a181d52989bb4342","10":"11da37bb2d53e0189863","11":"39fa462ffa130ce4c5c6","12":"9a837255fef28945ec9a","13":"ec0f4ae7ae2e99c2047a","14":"953f78ef27f2965d7d7a","15":"bb6366147092d225dd59","16":"f1d072c503f49ce99087","17":"f341868939fe8eec2f80","18":"f8cf4aa64c46ea340732","19":"289eb7d1ad98f9d357c6","20":"1f9bed1bcb5766b8c0f6","21":"cee9424bb4177902341a","22":"1a1e151420bc2030d8bf","23":"ff968f346fdf61d9c71a","24":"e680a68f96f82725f264","25":"48d5de777e98cd940573","26":"cf203c25669a15f15291","27":"6d681faabcc8d6fdc31f","28":"a25627b2d188f5055ddd","29":"cb5d0ef5a35737b34831","30":"1130e64b660173c81209","31":"639803d33f52c751c8db","32":"a7632c609222d7976802","33":"4c0354d3eb1628db2da4","34":"e2c8ecb0c74dd7f9fd28","35":"32dec35ccceb51699b42","36":"42a7599d727015bff2de","37":"05ec3c2b25dc46faadca","38":"301ff21fa0877f21ec87","39":"81b0d30abc71e7409d69","40":"85dcbbc1ff94b2ade140","41":"3163541c51da2b78427a","42":"bf90802019e9d99c20f2","43":"8964b6033b4ba6b4c2fb","44":"40ab847b9cb44a7463f4","45":"ada1727179d6635115ae","46":"d7d5ac5f95e61d227a32","47":"ae8b309bafef98e12b24","48":"6797e659ea7f2264dc39","49":"92a616611ae1e269f5d6","50":"1e8318f8abe05876ac25","51":"9eb7e7d75cd562e34a70","52":"bfb8654115519a2fca33","53":"0f476c41c7915bdf2165","54":"77efe7b335957f3a2b8f","57":"f536a58e05b67fad9e3e","58":"8b5f8bf267a654f1e45e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"4":1,"9":1,"10":1,"13":1,"15":1,"17":1,"18":1,"19":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"39":1,"40":1,"43":1,"44":1,"45":1,"48":1,"51":1,"57":1,"58":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app/" + ({"2":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","3":"vendors~Assessments~GoalDetails~LearnosityEduAuthor~MemberHomepage~ProgressTracker","4":"AssignmentsModal~AssignmentsModalV2~KidFrameDetail~TakeAssessmentModal","5":"AssignmentsV2~HomeLearning~PredefinedCollectionsDetail~SubPlansList","6":"vendors~Assessments~MyStudents~RegistrationModal~SwitchAccountModal","8":"AnonymousHomepage~RelatedGuidedLesson","9":"LandingPage~Pricing","10":"RegistrationModal~SwitchAccountModal","11":"vendors~Checkout~Gift","13":"AccountSettings","14":"AnonymousHomepage","15":"Assessments","16":"Assignments","17":"AssignmentsModal","18":"AssignmentsModalV2","19":"AssignmentsV2","20":"BackToSchoolBundle","21":"BrainzyPaint","22":"Checkout","23":"FeaturedArtwork","24":"Gift","25":"GoalDetails","26":"GradeFilteredContentCards","27":"GradeWorksheetModal","28":"HomeLearning","29":"KidFrame","30":"KidFrameDetail","31":"LandingPage","32":"LearnosityEduAuthor","33":"MemberHomepage","34":"MyCollections","35":"MyStudents","36":"Onboarding","37":"PracticeSkill","38":"PredefinedCollectionsDetail","39":"Pricing","40":"ProgressTracker","41":"RegistrationModal","42":"RelatedGuidedLesson","43":"Reviews","44":"SeasonalDaysDropdown","45":"Sellpage","46":"SubPlansList","47":"SwitchAccountModal","48":"TakeAssessmentModal","49":"vendors~AssignmentsV2","50":"vendors~Checkout","51":"vendors~Gift","52":"vendors~MemberHomepage","53":"vendors~MyStudents","54":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"834e3299209d51a8c3f1","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"d83f7d79e0dedcc0dc59","10":"6d4f794915d77ec75e9d","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"4ad35bb3dca41c2cae0b","14":"31d6cfe0d16ae931b73c","15":"27e431bd0818694fe781","16":"31d6cfe0d16ae931b73c","17":"873810f5a6a42c5b4f08","18":"eb2214ca25d23a3b9585","19":"a85ed26ea09a0cf62c2b","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"9b178eec9c3cf73696c2","23":"d56d9288e4c0c7368f48","24":"7c9ade4d0722da2d712c","25":"ba6307e6a97b2de53684","26":"721e02162f6078ce1480","27":"06bbf091aab95d64e8c5","28":"4c89bea8f7f35505c32a","29":"bf83b830e45e0058b7ae","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"8ad20e7a95d214ad9a49","33":"7e68eb506b58b8d495d0","34":"ab19f0324e469dc86f86","35":"708cac4ed1f9040a51c7","36":"c690fa1aa61d12f8135c","37":"5491656ee574e8b4a49d","38":"31d6cfe0d16ae931b73c","39":"1320f4897b7b95eaec24","40":"c34e0607236a0d8b7959","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"3eb70bdfce6885905434","44":"eaafc727492eb4363427","45":"ba010189d2bfdd022601","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"bf40f2159a5c06b0446f","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"ca68f8fa1dd9edae64fc","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","57":"c7c112df630d782cdeed","58":"c7c112df630d782cdeed"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([398,56]);
 	// run deferred modules when ready
 	return checkDeferredModules();
